export enum SocialMediaPlatformEnum {
  INSTAGRAM = 'instagram',
  TIKTOK = 'tiktok',
  FACEBOOK = 'facebook',
  YOUTUBE = 'youtube',
  BABELIO = 'babelio',
  BOOKNODE = 'booknode',
  LIVRADDICT = 'livraddict',
  GOODREADS = 'goodreads',
  X = 'x',
  BLUESKY = 'bluesky',
  GLEEPH = 'gleeph',
  // SNAPCHAT = 'snapchat',
  // LINKEDIN = 'linkedin',
  AMAZON = 'amazon',
  FNAC = 'fnac',
  DECITRE = 'decitre',
  // CULTURA = 'cultura',
  PLACE_DES_LIBRAIRES = 'place_des_libraires',
  FURET_DU_NORD = 'furet_du_nord',
  LALIBRAIRE = 'lalibrairie',
}
